import history from '../../util/history'

const toDailyClosingEditView = reservationId => {
  history.push(`/reservation/${reservationId}/daily/edit`)

  return true
}

export default toDailyClosingEditView
